import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";

import { Form, Input, Button, Select, DatePicker, Row } from "antd";
import PopupTriggerSchedule from "./PopupTriggerSchedule";
import * as actions from "../../store/actions/index";

import "@ant-design/compatible/assets/index.css";
import moment from "moment";

const { Option } = Select;

// const opetationTypes = {
//   CREATE: "Create",
//   UPDEATE: "Update",
// };

const envelopeTypes = {
  PRIMARY: "Primary",
  SECONDARY: "Secondary",
};

const triggerTypes = {
  CUT_OFF: "Cutoff",
  MANDATORY: "Mandatory",
};

const simpleOptionGenerator = (data, options) => {
  const optionList = Object.keys(data).map((key) => {
    let jsxOption = <></>;
    if (options) {
      if (options.useKforV) {
        jsxOption = <Option value={key}>{key}</Option>;
      } else if (options.useVforK) {
        jsxOption = <Option value={data[key]}>{data[key]}</Option>;
      }
    } else {
      jsxOption = <Option value={key}>{data[key]}</Option>;
    }

    return jsxOption;
  });

  return optionList;
};

// let nonFilterFields = [
//   "envelopeType",
//   "triggerType",
//   "triggerFrequency",
//   "triggerScheduleType",
//   "triggerSchedule",
//   "triggerIndex",
//   "triggerIndexValue",
//   "envelopeBusinessDate",
//   "signatureGoLiveDate",
// ];

const formStateObj = {
  hmgId: undefined,
  projectId: undefined,
  hotelId: undefined,
  envelopeType: "SECONDARY",
  triggerType: "MANDATORY",
  triggerFrequency: "Monthly",
  triggerScheduleType: undefined,
  triggerSchedule: undefined,
  triggerIndexId: undefined,
  triggerIndexValue: undefined,
  envelopeBusinessDate: undefined,
  signatureGoLiveDate: undefined,
};

const clearKeys = (obj, list) => {
  if (!list || list.length === 0) {
    list = Object.keys(obj);
  }

  list.forEach((key) => {
    obj[key] = undefined;
  });

  return obj;
};

const TrasparentText = (props) => {
  const { text } = props;
  return <span hidden>{text}</span>;
};

const SecondaryEnvelopeForm = (props) => {
  const { hmgData, projectData, hotelData, resetData } = props;

  const dispatch = useDispatch();

  const [formState, setFormState] = useState({ ...formStateObj });
  // const [hmgInit, setHmgInit] = useState(false);
  // const [projectInit, setProjectInit] = useState(false);
  const [indexValues, setIndexValues] = useState([]);
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [filteredHotels, setFilteredHotels] = useState([]);
  const [filteredIndexes, setFilteredIndexes] = useState([]);
  const [projectReportData, setProjectReportData] = useState(undefined);
  const [projectReportCategories, setProjectCategories] = useState([]);
  const [projectReports, setProjectReports] = useState([]);
  const [disableSubmitBtn, setDisableSubmitBtn] = useState(true);
  const [selectedIndex, setSelectedIndex] = useState(undefined);
  const [secEnvelope, setSecEnvelope] = useState(undefined);
  const [hotelChanged, setHotelChanged] = useState(false);

  const getFormState = () => {
    return { ...formState };
  };

  const hmgChange = (hmgId) => {
    let tempState = getFormState();
    tempState.hmgId = hmgId;

    tempState = clearKeys(tempState, [
      "projectId",
      "hotelId",
      "triggerIndexId",
      "triggerIndexValue",
      "triggerScheduleType",
      "triggerSchedule",
      "envelopeBusinessDate",
      "signatureGoLiveDate",
    ]);

    // Limit project to PNA
    const tempFilterProjects = projectData.filter((item) => {
      return item.hmg_id === hmgId && item.solution === "PNA";
    });

    setFormState(tempState);
    setSelectedIndex(undefined);
    setFilteredProjects(tempFilterProjects);
    setIndexValues([]);
    setHotelChanged(!hotelChanged);

    //temp remove init
    // if (!hmgInit) {
    //   setHmgInit(true);
    // }
  };

  const projectChange = async (projectId) => {
    let tempState = getFormState();
    tempState = clearKeys(tempState, [
      "hotelId",
      "triggerScheduleType",
      "triggerSchedule",
      "envelopeBusinessDate",
      "signatureGoLiveDate",
    ]);
    tempState.projectId = projectId;

    const tempFilteredHotels = hotelData.filter((item) => {
      return (
        projectId === item.primary_hmg_id ||
        projectId === item.secondary_hmg_id ||
        projectId === item.third_hmg_id ||
        projectId === item.fourth_hmg_id
      );
    });

    const filteredProject = projectData.filter((project) => {
      return project._id === projectId;
    })[0];

    // Limit index to Report Category
    let categoryIndexId = null;
    let tempFilteredIndexes = [];

    if (filteredProject && filteredProject.indexes) {
      tempFilteredIndexes = filteredProject.indexes.filter((item) => {
        if (item.index_id.name === "Report Category") {
          categoryIndexId = item.index_id._id;
          return true;
        }
        return false;
      });
    }

    tempFilteredIndexes = tempFilteredIndexes ? tempFilteredIndexes : [];

    tempState.triggerIndexId = categoryIndexId;

    setFormState(tempState);
    setFilteredIndexes(tempFilteredIndexes);
    setFilteredHotels(tempFilteredHotels);

    dispatch(actions.reportcategoryHmgReportCategories(projectId)).then(
      (result) => {
        console.log("CAT", result);
        setProjectReportData(result);
        setSelectedIndex(categoryIndexId);
        // triggerIndexChange(categoryIndexId, tempFilteredIndexes, tempState);
      },
    );

    setHotelChanged(!hotelChanged);
    //temp remove init
    // if (!projectInit) {
    //   setProjectInit(true);
    // }
  };

  const hotelChange = (hotelId) => {
    let tempState = getFormState();
    hotelId = hotelId.includes("all") ? ["all"] : hotelId
    tempState.hotelId = hotelId;
    tempState = clearKeys(tempState, ["triggerIndexValue"]);

    let tempProjectReportCategories = [];
    let tempProjectReports = [];

    if (projectReportData.hotels && projectReportData.reportcategories) {
      let allocatedReportCategories = [];
      projectReportData.hotels
        .filter((item) => {
          return hotelId[0] === "all" || hotelId.includes(item._id);
        })
        .forEach((item) => {
          allocatedReportCategories = allocatedReportCategories.concat(
            item.allocated_report_categories,
          );
          item.reports.forEach((report) => {
            tempProjectReports.push(report.report_id.ReportName);
          });
        });

      // removing duplicates
      allocatedReportCategories = [...new Set(allocatedReportCategories)];
      tempProjectReports = [...new Set(tempProjectReports)];

      tempProjectReportCategories = projectReportData.reportcategories
        .filter((item) => {
          return (
            item.apply_all_hotels ||
            allocatedReportCategories.includes(item._id)
          );
        })
        .map((item) => {
          return item.name;
        });
    }

    let preset = false;
    if (hotelId[0] && hotelId[0] !== "all") {
      const tempEnvelope = filteredHotels
        .filter((item) => {
          return hotelId.includes(item._id);
        })[0]
        .secondary_envelopes.filter((item) => {
          return item.proj_id === tempState.projectId;
        })[0];
      // alert(JSON.stringify(tempEnvelope))
      if (tempEnvelope && Object.keys(tempEnvelope).length > 0) {
        // tempState["envelopeType"] = tempEnvelope["envelope_type"];
        // tempState["triggerType"] = tempEnvelope["trigger_type"];
        // tempState["triggerFrequency"] = tempEnvelope["schedule_type"];
        tempState.triggerScheduleType = tempEnvelope.schedule_trigger_type;
        tempState.triggerSchedule = tempEnvelope.schedule_weekday;
        tempState.triggerIndexId = tempEnvelope.trigger_index;
        // tempState.triggerIndexValue = tempEnvelope.trigger_index_value;
        tempState.envelopeBusinessDate = tempEnvelope.envelope_business_date;
        tempState.signatureGoLiveDate = moment(
          tempEnvelope.signature_go_live_date,
        ).format("MM-DD-YYYY");
        setSecEnvelope(tempEnvelope);
        preset = true;
      }
    }

    if (!preset) {
      tempState = clearKeys(tempState, [
        "triggerScheduleType",
        "triggerSchedule",
        "envelopeBusinessDate",
        "signatureGoLiveDate",
      ]);
      setSecEnvelope(undefined);
    }

    setProjectCategories(tempProjectReportCategories);
    setProjectReports(tempProjectReports);
    setFormState(tempState);
    setHotelChanged(!hotelChanged);
  };

  const envelopeTypeChange = (envelopeType) => {
    let tempState = getFormState();
    tempState.envelopeType = envelopeType;
    setFormState(tempState);
  };

  const triggerTypeChange = (triggerType) => {
    let tempState = getFormState();
    tempState.triggerType = triggerType;
    setFormState(tempState);
  };

  const triggerFequencyChange = (triggerFrequencyValue) => {
    let tempState = getFormState();
    tempState.triggerFrequency = triggerFrequencyValue;

    tempState = clearKeys(tempState, [
      "triggerScheduleType",
      "triggerSchedule",
    ]);

    setFormState(tempState);
  };

  const triggerScheduleTypeChange = (triggerScheduleTypeValue) => {
    let tempState = getFormState();
    tempState.triggerScheduleType = triggerScheduleTypeValue;

    tempState = clearKeys(tempState, ["triggerSchedule"]);

    setFormState(tempState);
  };

  const triggerScheduleChange = (triggerScheduleVal) => {
    let tempState = getFormState();
    tempState.triggerSchedule = triggerScheduleVal;
    setFormState(tempState);
  };

  const triggerIndexChange = (triggerIndexId) => {
    let tempState = getFormState();
    tempState.triggerIndexId = triggerIndexId;
    tempState = clearKeys(tempState, ["triggerIndexValue"]);
    setFormState(tempState);
    setSelectedIndex(triggerIndexId);
  };

  useEffect(() => {
    if (!filteredIndexes) {
      return;
    }

    const index = filteredIndexes.filter((item) => {
      return item.index_id._id === selectedIndex;
    })[0];

    console.log("IDX", index);

    if (!index) {
      return;
    }

    if (index.custom_values) {
      setIndexValues(index.custom_values_data.values);
    } else {
      let tempIndexValues = [];
      switch (index.index_id.name) {
        case "Hotels":
          break;
        case "Report Name":
          tempIndexValues = projectReports;
          break;
        case "Report Category":
          tempIndexValues = projectReportCategories;
          break;
        case "Document Signed":
          tempIndexValues = ["yes", "no"];
          break;
        case "Submission Schedule":
          tempIndexValues = [
            "Daily",
            "Weekly",
            "Monthly",
            "Quarterly",
            "Yearly",
          ];
          break;
        default:
          break;
      }

      setIndexValues(tempIndexValues);
    }
  }, [selectedIndex, projectReportData, projectReportCategories]);

  useEffect(() => {
    if (secEnvelope) {
      const tempState = getFormState();
      tempState.triggerIndexValue = secEnvelope.trigger_index_value;
      console.log("FS", tempState);
      console.log("IDX VAL", indexValues);

      setFormState(tempState);
    }
  }, [indexValues]);

  const triggerIndexValueChange = (triggerIndexValue) => {
    let tempState = getFormState();
    tempState.triggerIndexValue = triggerIndexValue;
    setFormState(tempState);
  };

  const envelopeBusinessDateChange = (envelopeBusinessDateVal) => {
    let tempState = getFormState();
    tempState.envelopeBusinessDate = envelopeBusinessDateVal;
    setFormState(tempState);
  };

  const sigGoLiveChange = (date) => {
    let tempState = getFormState();
    tempState.signatureGoLiveDate = date ? date.format("MM-DD-YYYY") : date;
    setFormState(tempState);
  };

  useEffect(() => {
    const error = [];

    Object.keys(formState).forEach((key) => {
      if (!formState[key]) {
        error.push(key);
      }
    });

    if (error.length > 0) {
      setDisableSubmitBtn(true);
    } else {
      setDisableSubmitBtn(false);
    }
  }, [formState]);

  const formSubmit = () => {
    const error = [];
    console.log("SUB", formState);
    Object.keys(formState).forEach((key) => {
      if (!formState[key]) {
        error.push(key);
      }
    });

    if (error.length > 0) {
      console.error("Required :", error);
      return;
    }

    const requestBody = {
      hmgId: formState.hmgId,
      // projectId : formState.projectId,
      hotelId: formState.hotelId,
      secondaryEnvelope: {
        envelope_type: formState.envelopeType,
        trigger_type: formState.triggerType,
        schedule_type: formState.triggerFrequency,
        schedule_trigger_type: formState.triggerScheduleType,
        schedule_weekday:
          formState.triggerSchedule === "last day"
            ? "lastday"
            : formState.triggerSchedule,
        trigger_index: formState.triggerIndexId,
        trigger_index_value: formState.triggerIndexValue,
        envelope_business_date:
          formState.envelopeBusinessDate === "last day"
            ? "lastday"
            : formState.envelopeBusinessDate,
        signature_go_live_date: formState.signatureGoLiveDate,
        proj_id: formState.projectId,
      },
    };
    
    dispatch(actions.updateSecondaryEnvelope(requestBody)).then(() => {
      // resetData();
      window.location.reload();
    });
  };

  //temp remove auto hmg select
  // if (!hmgInit) {
  //   let initHMGId = hmgData.filter((item) => {
  //     // Test Dilshan
  //     return (
  //       item.hmg_name === process.env.REACT_APP_SECONDARY_ENVELOPE_DEFAULT_HMG
  //     );
  //   })[0];

  //   initHMGId = initHMGId ? initHMGId._id : initHMGId;

  //   if (initHMGId) {
  //     hmgChange(initHMGId);
  //   }
  // }

  // if (hmgInit && !projectInit) {
  //   let initProjectId = projectData.filter((item) => {
  //     return (
  //       item.hmg_id === formState.hmgId && item.solution.toUpperCase() === "PNA"
  //     );
  //   })[0];

  //   initProjectId = initProjectId ? initProjectId._id : initProjectId;

  //   if (initProjectId) {
  //     projectChange(initProjectId);
  //   }
  // }

  const popoupScheduleComponent = (
    <PopupTriggerSchedule
      triggerFrequency={formState.triggerFrequency}
      triggerScheduleType={formState.triggerScheduleType}
      setTriggerSchedule={triggerScheduleChange}
      placeholder="Enter Trigger Schedule"
      simpleOptionGenerator={simpleOptionGenerator}
      presetValue={formState.triggerSchedule}
      hotelChanged={hotelChanged}
    />
  );

  const triggerFrequency = {
    Daily: {
      triggerScheduleType: [
        {
          key: "Daily",
          value: 1,
          triggerSchedule: (
            <Select>
              <Option value="Daily">Daily</Option>
            </Select>
          ),
        },
      ],
    },
    Weekly: {
      triggerScheduleType: [
        {
          key: "Once a week",
          value: 1,
          triggerSchedule: (
            <Select>
              <Option value="Monday">Monday</Option>
              <Option value="Tuesday">Tuesday</Option>
              <Option value="Wednesday">Wednesday</Option>
              <Option value="Thursday">Thursday</Option>
              <Option value="Friday">Friday</Option>
              <Option value="Saturday">Saturday</Option>
              <Option value="Sunday">Sunday</Option>
            </Select>
          ),
        },
      ],
    },
    Monthly: {
      triggerScheduleType: [
        {
          key: "Date of the Month",
          value: 1,
          triggerSchedule: popoupScheduleComponent,
        },
        {
          key: "Week of the Month",
          value: 2,
          triggerSchedule: popoupScheduleComponent,
        },
      ],
    },
    Quarterly: {
      triggerScheduleType: [
        {
          key: "Date of Month",
          value: 1,
          triggerSchedule: popoupScheduleComponent,
        },
        {
          key: "Week of Month",
          value: 2,
          triggerSchedule: popoupScheduleComponent,
        },
      ],
    },
    Yearly: {
      triggerScheduleType: [
        {
          key: "Date of Month",
          value: 1,
          triggerSchedule: popoupScheduleComponent,
        },
        {
          key: "Week of Month",
          value: 2,
          triggerSchedule: popoupScheduleComponent,
        },
      ],
    },
  };

  return (
    <Form
      labelCol={{ span: 5 }}
      wrapperCol={{ span: 12 }}
      name="secondaryEnvelopeForm"
    >
      {/* HMG */}
      <Form.Item
        // name="hmg"
        label="Hotel Management Group"
        required
      >
        <Select
          showSearch
          placeholder="Enter Hotel Management Group"
          onChange={hmgChange}
          optionFilterProp="children"
          notFoundContent={null}
          value={formState.hmgId}
        >
          {hmgData
            .sort((a, b) => {
              return a.hmg_name.localeCompare(b.hmg_name);
            })
            .map((d) => {
              return (
                <Option key={`HMG${d._id}`} value={d._id}>
                  {d.hmg_name}
                </Option>
              );
            })}
        </Select>
      </Form.Item>

      {/* PROJECT */}
      <Form.Item
        // name="project"
        label="Project Name"
        required
      >
        {formState.hmgId ? (
          <Select
            showSearch
            placeholder="Enter Project"
            onChange={projectChange}
            optionFilterProp="children"
            notFoundContent={null}
            value={formState.projectId}
          >
            {filteredProjects
              .sort((a, b) => {
                return a.project_name.localeCompare(b.project_name);
              })
              .map((d) => {
                return (
                  <Option key={`P${d._id}`} value={d._id} selected>
                    {d.project_name}
                  </Option>
                );
              })}
          </Select>
        ) : (
          <Input disabled placeholder="Enter Project" />
        )}
      </Form.Item>

      {/* HOTEL */}
      <Form.Item
        // name="hotel"
        label="Hotel Name"
        required
      >
        {formState.projectId ? (
          <Select
            showSearch
            placeholder="Enter Hotel"
            onChange={hotelChange}
            optionFilterProp="children"
            notFoundContent={null}
            value={formState.hotelId}
            mode="multiple"
          >
            {filteredHotels.length > 1 ? (
              <Option key="all" value="all">
                All
              </Option>
            ) : null}
            {filteredHotels
              .sort((a, b) => {
                return a.hotel_code.localeCompare(b.hotel_code);
              })
              .map((d) => {
                return (
                  <Option key={`H${d._id}`} value={d._id}>
                    {`${d.hotel_code} - ${d.hotel_name}`}
                  </Option>
                );
              })}
          </Select>
        ) : (
          <Input disabled placeholder="Enter Hotel" />
        )}
      </Form.Item>

      {/* ENVELOPE TYPE */}
      <Form.Item
        // name="envelopeType"
        label="Envelope Type"
        required
      >
        <Select
          showSearch
          placeholder="Enter Envelope Type"
          optionFilterProp="children"
          notFoundContent={null}
          initialValue={formState.envelopeType}
          value={formState.envelopeType}
          disabled
          onChange={envelopeTypeChange}
        >
          {simpleOptionGenerator(envelopeTypes)}
        </Select>
      </Form.Item>

      {/* TRIGGER TYPE */}
      <Form.Item
        // name="triggerType"
        label="Trigger Type"
        required
      >
        <Select
          showSearch
          placeholder="Enter Trigger Type"
          optionFilterProp="children"
          notFoundContent={null}
          initialValue={formState.triggerType}
          value={formState.triggerType}
          disabled
          onChange={triggerTypeChange}
        >
          {simpleOptionGenerator(triggerTypes)}
        </Select>
      </Form.Item>

      {/* TRIGGER FREQUENCY */}
      <Form.Item
        // name="triggerFrequency"
        label="Trigger Frequency"
        required
      >
        <Select
          showSearch
          placeholder="Enter Trigger Frequency"
          optionFilterProp="children"
          onChange={triggerFequencyChange}
          notFoundContent={null}
          disabled
          value={formState.triggerFrequency}
        >
          {simpleOptionGenerator(triggerFrequency, { useKforV: true })}
        </Select>
      </Form.Item>

      {/* TRIGGER SCHEDULE TYPE */}
      <Form.Item
        // name="triggerScheduleType"
        label="Trigger Schedule Type"
        required
      >
        <Select
          showSearch
          placeholder="Enter Trigger Schedule Type"
          optionFilterProp="children"
          notFoundContent={null}
          onChange={triggerScheduleTypeChange}
          value={formState.triggerScheduleType}
        >
          {formState.triggerFrequency ? (
            triggerFrequency[
              formState.triggerFrequency
            ].triggerScheduleType.map((scheduleType) => {
              return (
                <Option value={scheduleType.value}>{scheduleType.key}</Option>
              );
            })
          ) : (
            <Input disabled placeholder="Enter Trigger Schedule Type" />
          )}
        </Select>
      </Form.Item>

      {/* TRIGGER SCHEDULE */}
      <Form.Item
        // name="triggerSchedule"
        label="Trigger Schedule"
        required
      >
        {formState.triggerFrequency && formState.triggerScheduleType ? (
          triggerFrequency[
            formState.triggerFrequency
          ].triggerScheduleType.filter((scheduleType) => {
            return scheduleType.value === formState.triggerScheduleType;
          })[0].triggerSchedule
        ) : (
          <Input disabled placeholder="Enter Trigger Schedule" />
        )}
        <TrasparentText text={formState.triggerSchedule} />
      </Form.Item>

      {/* TRIGGER INDEX */}
      <Form.Item
        // name="triggerIndex"
        label="Trigger Index"
        required
      >
        {filteredIndexes.length > 0 ? (
          <Select
            showSearch
            placeholder="Enter Trigger Index"
            optionFilterProp="children"
            onChange={triggerIndexChange}
            notFoundContent={null}
            disabled
            value={formState.triggerIndexId}
          >
            {filteredIndexes.map((index) => {
              return (
                <Option
                  key={`IDX${index.index_id._id}`}
                  value={index.index_id._id}
                >
                  {index.index_id.name}
                </Option>
              );
            })}
          </Select>
        ) : (
          <Input disabled />
        )}
      </Form.Item>

      {/* TRIGGER INDEX VALUE */}
      <Form.Item name="triggerIndexValue" label="Trigger Index Value" required>
        {formState.triggerIndexId && indexValues.length > 0 ? (
          <>
            <Select
              showSearch
              placeholder="Enter Trigger Value"
              optionFilterProp="children"
              notFoundContent={null}
              onChange={triggerIndexValueChange}
              value={formState.triggerIndexValue}
              mode="multiple"
            >
              {indexValues.map((item) => {
                return (
                  <Option key={`IDXV${item}`} value={item}>
                    {item}
                  </Option>
                );
              })}
            </Select>
            <TrasparentText text={formState.triggerIndexValue} />
          </>
        ) : (
          <Input disabled value="" />
        )}
      </Form.Item>

      {/* ENVELOPE BUSINESS DATE */}
      <Form.Item
        name="envelopeBusinessDate"
        label="Envelope Business Date"
        required
      >
        <PopupTriggerSchedule
          triggerFrequency="Monthly"
          triggerScheduleType={1}
          setTriggerSchedule={envelopeBusinessDateChange}
          placeholder="Enter Envelope Business Date"
          presetValue={formState.envelopeBusinessDate}
          hotelChanged={hotelChanged}
        />
        <TrasparentText text={formState.envelopeBusinessDate} />
      </Form.Item>

      {/* SIGNATURE GO LIVE DATE */}
      <Form.Item
        name="signatureGoLiveDate"
        label="Signature Go Live Date"
        required
      >
        <DatePicker
          format="MM-DD-YYYY"
          placeholder="MM-DD-YYYY"
          onChange={sigGoLiveChange}
          value={
            formState.signatureGoLiveDate
              ? moment(formState.signatureGoLiveDate, "MM-DD-YYYY")
              : null
          }
        />
        <TrasparentText text={formState.signatureGoLiveDate} />
      </Form.Item>

      {/* CONTROLS */}
      <Form.Item>
        <Row justify="center">
          <Button
            type="primary"
            onClick={formSubmit}
            disabled={disableSubmitBtn}
          >
            Submit
          </Button>
        </Row>
      </Form.Item>
    </Form>
  );
};

export default SecondaryEnvelopeForm;
